import React from 'react';
import HomeBanner from '../components/home/HomeBanner';
import HomeServices from '../components/home/HomeServices';
import HomeProjects from '../components/home/HomeProjects';
import HomeExperts from '../components/home/HomeExperts';
import HomeFeature from '../components/home/HomeFeature';
import HomeTestimonial from '../components/home/HomeTestimonial';

const Home = () => {
  return (
    <React.Fragment>
      <HomeBanner />
      <HomeServices />
      <HomeProjects />
      <HomeExperts />
      <HomeFeature />
      <HomeTestimonial />
    </React.Fragment>
  );
};

export default Home;
